import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import FormalQuotePage from 'formal_quote/FormalQuotePage';
import store from 'formal_quote/store';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('formal-quote-form');

  if (appContainer != null) {
    render(
      <Provider store={store}>
        <FormalQuotePage />
      </Provider>,
      appContainer,
    );
  }
});
